import { api } from './api.service';

/**
 * Vehicle watchlist API — Cloud FE → Cloud BE → tunnel → local command-center.
 *
 * Double-wrapped like every other analytics read: the command-center returns its own
 * { success, data, pagination } envelope, which the cloud BE wraps again as
 * { success, message, data: <cc-envelope> }. `unwrap` peels both; `unwrapPaginated` stops one
 * level short, because the list needs the pagination block the inner envelope carries.
 */
const base = (nodeId: string) => `/nodes/${nodeId}/analytics/vehicle-blacklist`;

const unwrap = (resp: any) => {
  const inner = resp?.data?.data;
  return inner && typeof inner === 'object' && 'success' in inner && 'data' in inner ? inner.data : inner;
};
const unwrapPaginated = (resp: any) => resp?.data?.data;

export async function listVehicleBlacklist(nodeId: string, params: any = {}) {
  return unwrapPaginated(await api.get(base(nodeId), { params }));
}
export async function addVehicleBlacklist(nodeId: string, data: any) {
  return unwrap(await api.post(base(nodeId), data));
}
export async function updateVehicleBlacklist(nodeId: string, id: string, data: any) {
  return unwrap(await api.put(`${base(nodeId)}/${id}`, data));
}
export async function deleteVehicleBlacklist(nodeId: string, id: string) {
  return unwrap(await api.delete(`${base(nodeId)}/${id}`));
}
export async function checkVehicleBlacklist(nodeId: string, plate: string) {
  return unwrap(await api.get(`${base(nodeId)}/check`, { params: { plate } }));
}
